import TemplateModel from 'cio/models/template';
import { DEFAULT_SOUND } from 'cio/utils/push/defaults';
import { Editor } from 'cio/services/editor';
import ComposerEditableEntity from 'cio/utils/composer/composer-editable-entity';

export const getPushPreviewMeta = (
  template: TemplateModel,
  providers: { iosProvider: any; androidProvider: any },
  editableEntity?: ComposerEditableEntity,
) => {
  if (template.editor === Editor.JSON) {
    return {
      to: template.recipient,
      body: template.bodyJson,
      has_json: true,
      platform: editableEntity?.action?.sendToPlatform ?? editableEntity?.newsletter?.sendToPlatform ?? 'all',
    };
  }

  if (template.editor === Editor.RICH) {
    let { deepLink, customDataStr, sound } = richFields(template);
    let { iosProvider, androidProvider } = providers;

    return {
      to: template.recipient,
      title: template.subject,
      image_url: template.imageUrl,
      body: template.body,
      sound,
      link: deepLink,
      custom_data: customDataStr,
      is_rich: true,
      ios_provider: iosProvider,
      android_provider: androidProvider,
    };
  }
  let { sound } = richFields(template);

  return {
    to: template.recipient,
    body: template.body,
    title: template.subject,
    sound,
  };
};

const richFields = (template: TemplateModel) => {
  let deepLink = '';
  let customDataStr = '{}';
  let sound = DEFAULT_SOUND;
  try {
    let parsedBodyJson = JSON.parse(template.bodyJson);
    deepLink = parsedBodyJson.link;
    customDataStr = parsedBodyJson.custom_data;
    sound = parsedBodyJson.sound;
  } catch {}
  return { deepLink, customDataStr, sound };
};
